import * as types from "./mutation-types";
import { API_STATES } from "@/helpers";

const mutations = {
  [types.GET_REQUESTTYPES_BEGIN](state) {
    state.requestTypesGetState = API_STATES.REQUEST_PENDING;
  },
  [types.GET_REQUESTTYPES_SUCCESS](state, requestTypes) {
    state.requestTypesGetError = null;
    state.requestTypes = requestTypes;
    state.requestTypesGetState = API_STATES.REQUEST_SUCCESS;
  },
  [types.GET_REQUESTTYPES_ERROR](state, err) {
    state.requestTypesGetState = API_STATES.REQUEST_ERROR;
    state.requestTypesGetError = err;
  },

  [types.DELETE_REQUESTTYPE_BEGIN](state) {
    state.requestTypeDeleteState = API_STATES.REQUEST_PENDING;
  },
  [types.DELETE_REQUESTTYPE_SUCCESS](state) {
    state.requestTypeDeleteError = null;
    state.requestTypeDeleteState = API_STATES.REQUEST_SUCCESS;
  },
  [types.DELETE_REQUESTTYPE_ERROR](state, err) {
    state.requestTypeDeleteState = API_STATES.REQUEST_ERROR;
    state.requestTypeDeleteError = err;
  },
  [types.CREATE_REQUESTTYPE_BEGIN](state) {
    state.requestTypeCreateState = API_STATES.REQUEST_PENDING
  },
  [types.CREATE_REQUESTTYPE_SUCCESS](state, data) {
    state.requestTypeCreateError = null
    state.requestTypeCreateState = API_STATES.REQUEST_SUCCESS
    state.requestType=data
  },
  [types.CREATE_REQUESTTYPE_ERROR](state, err) {
    state.requestTypeCreateState = API_STATES.REQUEST_ERROR
    state.requestTypeCreateError = err
  },

  [types.UPDATE_REQUESTTYPE_BEGIN](state) {
    state.requestTypeUpdateState = API_STATES.REQUEST_PENDING
  },
  [types.UPDATE_REQUESTTYPE_SUCCESS](state, data) {
    state.requestTypeUpdateError = null
    state.requestType=data
    state.requestTypeUpdateState = API_STATES.REQUEST_SUCCESS
  },
  [types.UPDATE_REQUESTTYPE_ERROR](state, err) {
    state.requestTypeUpdateState = API_STATES.REQUEST_ERROR
    state.requestTypeUpdateError = err
  },
};

export default mutations;